import { useEffect, useState } from "react";
import { ActiveProjectStore, ActiveProjectStoreProvider } from "@stores";
import {
  getCompanyRateCardQuery,
  getCompanySettingsQuery,
  setCompanySettingsQuery,
} from "@query";
import { TemplatesView } from "./TemplatesView";
import { PageCircularProgress } from "@components";
import { COMPANY_SETTINGS } from "@client";
import { TemplatesDataProvider } from "@hooks";
import { observer } from "mobx-react";

export const Templates =  observer(() => {
  
  const [ defaultTemplateId, setDefaultTemplateId ] = useState();
  
  const [ activeProjectStore ] = useState(new ActiveProjectStore());
  
  useEffect(() => {
    load();
  }, []);
  
  const load = async () => {
    const templateId = await getCompanySettingsQuery(COMPANY_SETTINGS.TEMPLATE);
    const wT = await getCompanyRateCardQuery();
    setDefaultTemplateId(templateId);
    activeProjectStore.setWorkTypes(wT);
  };
  
  const handleDefaultTemplateId = async (templateId) => {
    setDefaultTemplateId(templateId);
    await setCompanySettingsQuery(COMPANY_SETTINGS.TEMPLATE, templateId);
  }
  
  return !activeProjectStore.workTypes
    ? <PageCircularProgress/>
    : (
      <ActiveProjectStoreProvider value={activeProjectStore}>
        <TemplatesDataProvider limit={12}>
          <TemplatesView
            defaultTemplateId={defaultTemplateId}
            setDefaultTemplateId={handleDefaultTemplateId}
          />
        </TemplatesDataProvider>
      </ActiveProjectStoreProvider>
    );
});
